import React from 'react';
import classNames from 'classnames';

import css from './Card.module.css';

/**
 * A white box with the standard border, corners and padding. `title` renders the card's
 * section title (an h2 unless `titleAs` says otherwise); `actions` sit to its right.
 */
const Card = ({
  as: Tag = 'section',
  title,
  titleAs: TitleTag = 'h2',
  actions,
  className,
  rootClassName,
  children,
  ...rest
}) => (
  <Tag className={classNames(rootClassName || css.root, className)} {...rest}>
    {title || actions ? (
      <div className={css.head}>
        {title ? <TitleTag className={css.title}>{title}</TitleTag> : null}
        {actions ? <div className={css.actions}>{actions}</div> : null}
      </div>
    ) : null}
    {children}
  </Tag>
);

export default Card;
